import FloatingInput from "../fields/FloatingInput";

interface StepMessageProps {
  value: string;
  onChange: (name: string, value: string) => void;
}

export default function StepMessage({ value, onChange }: StepMessageProps) {
  return (
    <fieldset style={{ border: "none" }}>
      <legend
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 12,
          display: "block",
          width: "100%",
        }}
      >
        Si vous le souhaitez, décrivez nous votre projet !
      </legend>
      <FloatingInput
        name="message"
        label="Parlez nous de votre projet"
        value={value}
        onChange={onChange}
        maxLength={2000}
        isTextarea
        rows={4}
      />
    </fieldset>
  );
}
